import { AccountLinking } from './account-linking';

export interface Session {
  accessToVendor: boolean | null;
  accountLinking: AccountLinking;
  disabled: boolean;
  email: string;
  expires: string;
  token: string;
}
